import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '~components/button';
import ErrorContainer from '~containers/common-pages/error-container';

const useStyles = makeStyles(() => ({
  button: {
    marginTop: 24,
  },
}));

function PageCrash() {
  const classes = useStyles();
  const { t } = useTranslation('common-pages');

  const reload = () => {
    // use window.location to reload the whole page to clear all states which could be wrong
    window.location.reload();
  };

  return (
    <ErrorContainer description={t('common-pages.crash')}>
      <Button color="primary" className={classes.button} onClick={reload}>
        {t('common-pages.reload_page')}
      </Button>
    </ErrorContainer>
  );
}

export default PageCrash;
